/**
 * Shared schema-snapshot lifetime for every engine's native schema cache
 * (`pgSchemaCache` / `mysqlSchemaCache` / `oracleSchemaCache` /
 * `sqliteSchemaCache`, and `mssqlTableCache` once it adopts this constant).
 *
 * S7 item 3 — "kill the minute-ly refresh". A snapshot used to expire after
 * 30 s in the caches and 60 s at the language-service providers, so the whole
 * introspection fan-out re-ran roughly every minute while the user was
 * editing. On a large production database that froze the renderer for seconds
 * at a time (the POSMOTHER repro in `goals/autocomplete-coverage/SLICES.md`).
 *
 * A snapshot is now built ONCE per `(connection, database)` and rebuilt only
 * by an explicit trigger:
 *   - the DDL invalidator (`workspace/common/utils/ddlInvalidator.ts` →
 *     `invalidateSchemaBus` plus each cache's drop/invalidate hook),
 *   - an explicit user/harness refresh (`forceRefresh: true`),
 *   - reconnect or disconnect (`schemaBus.invalidateConnection`).
 *
 * This constant is therefore a backstop, not a refresh cadence — it only
 * matters for an app instance left connected for most of a day. Six hours is
 * long enough that no editing session reaches it, short enough that a
 * genuinely abandoned snapshot eventually rebuilds.
 *
 * Callers that need a short, deliberate TTL (E2E specs, one-off warm-ups)
 * still pass an explicit `ttlMs` to `ensure…Schema`.
 */
export const SNAPSHOT_STALE_AFTER_MS = 6 * 60 * 60 * 1000;
